import axios from "@/plugins/axios";

export default {
  addQueue(data) {
    return axios.post("/email_delivery/queue", data);
  },
  getQueueList(limit, cursor) {
    return axios.get("/email_delivery/queue", { params: { limit, cursor } });
  },
  getHistoryList(limit, cursor) {
    return axios.get("/email_delivery/history", { params: { limit, cursor } });
  },
  clearHistory() {
    return axios.delete("/email_delivery/history");
  },
  resendEmail(id) {
    return axios.post(`/email_delivery/queue/${id}/resend`);
  },
  deleteQueueEmail(id) {
    return axios.delete(`/email_delivery/queue/${id}`);
  },
};
